export default function doesObjectHaveField(object, field) {
  return Object.prototype.hasOwnProperty.call(object, field);
}
